<template>
  <ul class="towmenu">
    <li v-for="(item,i) in menuList" :key="i" @click="tab(item,i)" :class="activelen==i?'active':'active1'">
      <img class="icons iconfont" v-if="activelen==i" :src="item.activeicon"/>
      <img class="icons iconfont" v-else :src="item.icon"/>
      <!-- <span class="icons iconfont" :class="item.css"></span> -->
      <p class="menutext">{{item.name}}</p>
    </li>
  </ul>
</template>

<script>
  import towMenu from '../../common/js/towmenuPng';
  export default {
    data() {
      return {
        menuList: [],
        activelen: 0,
        towMenu
      }
    },

    computed: {
      twomenulists() { //监听二级菜单变化
        return this.$store.state.towMenulist; //需要监听的数据
      },
    },
    mounted() {},
    methods: {
      tab(item, i) {
        this.activelen = i;
        this.$router.replace(item.url)
      },

    },
    watch: {
      /*$route(to, from){
      	console.log(to)
      }*/

      twomenulists(newVal, oldVal) {
        this.activelen = 0;
        this.menuList = newVal;
         console.log('3.21上午', this.menuList)
         console.log('3.21下午', this.activelen)
        for (let i=0; i<this.menuList.length; i++) {
          //基础数据管理
          if (this.menuList[i].url == 'user') {
            this.menuList[i].icon  = towMenu.towMenu.user;
            this.menuList[i].activeicon  = towMenu.towMenu.user_active;
          }
          if (this.menuList[i].url == 'menu') {
            this.menuList[i].icon  = towMenu.towMenu.menu;
            this.menuList[i].activeicon  = towMenu.towMenu.menu_active;
          }
          if (this.menuList[i].url == 'organization') {
            this.menuList[i].icon  = towMenu.towMenu.organization;
            this.menuList[i].activeicon  = towMenu.towMenu.organization_active;
          }
          if (this.menuList[i].url == 'role') {
            this.menuList[i].icon  = towMenu.towMenu.role;
            this.menuList[i].activeicon  = towMenu.towMenu.role_active;
          }
          if (this.menuList[i].url == 'journal') {
            this.menuList[i].icon  = towMenu.towMenu.journal;
            this.menuList[i].activeicon  = towMenu.towMenu.journal_active;
          };
          if (this.menuList[i].url == 'dictionaries') {
            this.menuList[i].icon  = towMenu.towMenu.dictionaries;
            this.menuList[i].activeicon  = towMenu.towMenu.dictionaries_active;
          }
          //淤地坝基本情况
          if (this.menuList[i].url == 'essentialinformation') {
            this.menuList[i].icon  = towMenu.towMenu.essentialinformation;
            this.menuList[i].activeicon  = towMenu.towMenu.essentialinformation_active;
          }
          if (this.menuList[i].url == 'register') {
            this.menuList[i].icon  = towMenu.towMenu.register;
            this.menuList[i].activeicon  = towMenu.towMenu.register_active;
          }
          if (this.menuList[i].url == 'dexam') {
            this.menuList[i].icon  = towMenu.towMenu.dexam;
            this.menuList[i].activeicon  = towMenu.towMenu.dexam_active;
          }
          if (this.menuList[i].url == 'yexam') {
            this.menuList[i].icon  = towMenu.towMenu.yexam;
            this.menuList[i].activeicon  = towMenu.towMenu.yexam_active;
          }
          if (this.menuList[i].url == 'reject') {
            this.menuList[i].icon  = towMenu.towMenu.reject;
            this.menuList[i].activeicon  = towMenu.towMenu.reject_active;
          };
          if (this.menuList[i].url == 'personliable') {
            this.menuList[i].icon  = towMenu.towMenu.personliable;
            this.menuList[i].activeicon  = towMenu.towMenu.personliable_active;
          }
          if (this.menuList[i].url == 'qrcordManage') {
            this.menuList[i].icon  = towMenu.towMenu.qrcordManage;
            this.menuList[i].activeicon  = towMenu.towMenu.qrcordManage_active;
          }
          if (this.menuList[i].url == 'yjdc') {
            this.menuList[i].icon  = towMenu.towMenu.register;
            this.menuList[i].activeicon  = towMenu.towMenu.register_active;
          }
          //涉河监控
          if(this.menuList[i].url == 'shessenlinfo'){
            this.menuList[i].icon  = towMenu.towMenu.shessenlinfo;
            this.menuList[i].activeicon  = towMenu.towMenu.shessenlinfo_active;
          }
          if(this.menuList[i].url == 'shpersonliable'){
            this.menuList[i].icon  = towMenu.towMenu.shpersonliable;
            this.menuList[i].activeicon  = towMenu.towMenu.shpersonliable_active;
          }
          //知识库
          if(this.menuList[i].url == 'knowledgebase'){
            this.menuList[i].icon  = towMenu.towMenu.knowledgebase;
            this.menuList[i].activeicon  = towMenu.towMenu.knowledgebase_active;
          }
          //安全监测
          if (this.menuList[i].url == 'sensor') {
            this.menuList[i].icon  = towMenu.towMenu.sensor;
            this.menuList[i].activeicon  = towMenu.towMenu.sensor_active;
          }
          if (this.menuList[i].url == 'drawstring') {
            this.menuList[i].icon  = towMenu.towMenu.drawstring;
            this.menuList[i].activeicon  = towMenu.towMenu.drawstring_active;
          }
          if (this.menuList[i].url == 'waterlevelgauge') {
            this.menuList[i].icon  = towMenu.towMenu.waterlevelgauge;
            this.menuList[i].activeicon  = towMenu.towMenu.waterlevelgauge_active;
          }
          if (this.menuList[i].url == 'raingauge') {
            this.menuList[i].icon  = towMenu.towMenu.raingauge;
            this.menuList[i].activeicon  = towMenu.towMenu.raingauge_active;
          }
          if (this.menuList[i].url == 'rain') {
            this.menuList[i].icon  = towMenu.towMenu.rain;
            this.menuList[i].activeicon  = towMenu.towMenu.rain_active;
          }
          if (this.menuList[i].url == 'Videomonitor') {
            this.menuList[i].icon  = towMenu.towMenu.Videomonitor;
            this.menuList[i].activeicon  = towMenu.towMenu.Videomonitor_active;
          }
          //防汛管理
          
          if (this.menuList[i].url == 'earlyWarning') {
            this.menuList[i].icon  = towMenu.towMenu.earlyWarning;
            this.menuList[i].activeicon  = towMenu.towMenu.earlyWarning_active;
          }
          if (this.menuList[i].url == 'beonduty') {
            this.menuList[i].icon  = towMenu.towMenu.beonduty;
            this.menuList[i].activeicon  = towMenu.towMenu.beonduty_active;
          }
          if (this.menuList[i].url == 'controlpoint') {
            this.menuList[i].icon  = towMenu.towMenu.controlpoint;
            this.menuList[i].activeicon  = towMenu.towMenu.controlpoint_active;
          }
          if (this.menuList[i].url == 'reserveplan') {
            this.menuList[i].icon  = towMenu.towMenu.reserveplan;
            this.menuList[i].activeicon  = towMenu.towMenu.reserveplan_active;
          }
          if (this.menuList[i].url == 'managementsystem') {
            this.menuList[i].icon  = towMenu.towMenu.managementsystem;
            this.menuList[i].activeicon  = towMenu.towMenu.managementsystem_active;
          }
          if (this.menuList[i].url == 'funds') {
            this.menuList[i].icon  = towMenu.towMenu.funds;
            this.menuList[i].activeicon  = towMenu.towMenu.funds_active;
          }
          //巡查维护
          if (this.menuList[i].url == 'inspectionplan') {
            this.menuList[i].icon  = towMenu.towMenu.inspectionplan;
            this.menuList[i].activeicon  = towMenu.towMenu.inspectionplan_active;
          }
          if (this.menuList[i].url == 'hiddenmanagement') {
            this.menuList[i].icon  = towMenu.towMenu.hiddenmanagement;
            this.menuList[i].activeicon  = towMenu.towMenu.hiddenmanagement_active;
          }
          //应急管理
          if (this.menuList[i].url == 'emergencysupplies') {
            this.menuList[i].icon  = towMenu.towMenu.emergencysupplies;
            this.menuList[i].activeicon  = towMenu.towMenu.emergencysupplies_active;
          }
          if (this.menuList[i].url == 'emergencydnill') {
            this.menuList[i].icon  = towMenu.towMenu.emergencydnill;
            this.menuList[i].activeicon  = towMenu.towMenu.emergencydnill_active;
          }
          //安全保障
          if (this.menuList[i].url == 'repair') {
            this.menuList[i].icon  = towMenu.towMenu.repair;
            this.menuList[i].activeicon  = towMenu.towMenu.repair_active;
          }
          //暗访督查
          if (this.menuList[i].url == 'supervision') {
            this.menuList[i].icon  = towMenu.towMenu.supervision;
            this.menuList[i].activeicon  = towMenu.towMenu.supervision_active;
          }
        }

        this.$router.replace(newVal[0].url)
      },
    }
  }
</script>

<style scoped>
  .towmenu {
    position: absolute;
    left: 0px;
    top: 60px;
    width: 60px;
    bottom: 0px;
    background: #0040a1;
    overflow: auto;
  }

  .towmenu li {
    width: 60px;
    height: 80px;
    overflow: hidden;
    cursor: pointer;
    border-bottom: 1px solid #2e73da;
  }

  .icons {
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
    margin-top: 18px;
    line-height: 20px;
    font-size: 20px;
    /* background: #ccc; */
  }

  .menutext {
    width: 58px;
    height: 32px;
    font-size: 12px;
    line-height: 14px;
    margin: 0 auto;
    margin-top: 5px;
    letter-spacing: 0px;
    text-align: center;
    -moz-user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    user-select: none;
    padding: 0 1px;
  }

  .active {
    background: url(../../common/images/towbg.png)no-repeat center !important;
    background-size: 100% 100% !important;
    color: #fde458 !important;
  }

  .active1 {
    color: #fff;
  }
</style>
